<template>
    <div class="p-3">  
        <form-modal
            id="cronograma"
            placeholder-button="Inserir etapa" 
            :fields="cols"
            :values="rows"
            
            @ok="salvar"
            @cancel="inicializarForm"
            @remove="remover"
            @rowClick="editar"

            ref="modal"
            :title-modal="tituloModal"
            is-gantt
            is-gantt-multiple
            
            :remove-enabled="form.id != null && permissao.d"
            :ok-cancel="(form.id != null && !(form.id != null ? permissao.u : permissao.c)) || !controlesLiberados"
            :somente-ok="(form.id != null && !(form.id != null ? permissao.u : permissao.c)) || !controlesLiberados"

            :create="controlesLiberados && permissao.c"
            :read="controlesLiberados && permissao.r"
            :update="controlesLiberados && permissao.u"
            :remove="controlesLiberados && permissao.d"   

            controles   
        >
            <template #modal>
                <modal 
                    :projeto-iniciado="projetoIniciado" 
                    :duracao="duracao" 
                    :data-inicio="!projetoIniciado ? projeto.anoInicio : projeto.dataInicio" 
                    :form="form" 
                    :numero-etapa="(dados ? ( dados.length == 0 ? 1 : parseInt(dados[dados.length - 1].etapa.numero) + 1 ) : 1)"  
                    
                    ref="form" 
                    @update="buscar" 
                />
            </template>
        </form-modal>

        <hr class="row">
        <div class="row">
            <div class="col-12 col-md-2" style="display:flex;font-size: 12px;">
                <div class="bg-gradient-info round mr-2"></div>
                <span>Previsto</span>
            </div>
            <div class="col-12 col-md-2" style="display:flex;font-size: 12px;">
                <div class="bg-gradient-primary round mr-2"></div>
                <span>Etapa não prevista</span>
            </div>
            <div class="col-12 col-md-2" style="display:flex;font-size: 12px;">
                <div class="bg-gradient-success round mr-2"></div>
                <span>Concluído no prazo</span>
            </div>
            <div class="col-12 col-md-3" style="display:flex;font-size: 12px;">
                <div class="bg-gradient-warning round mr-2"></div>
                <span>Concluído em atraso</span>
            </div>
            <div class="col-12 col-md-3" style="display:flex;font-size: 12px;">
                <div class="bg-gradient-danger round mr-2"></div>
                <span>Concluída antecipadamente</span>
            </div>
        </div>
    </div>
</template>
<script>
import ProjetoGestaoService from "@/common/services/projeto_gestao/projeto_gestao.service";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import FormModal from "@/components/modal/FormModal";
import cloneDeep from "lodash/cloneDeep";
import helpers from "@/common/utils/helpers";

import modal from "./modal.vue";

export default {
    mixins: [AlertasMixin],
    components: {
        FormModal,
        modal
    },
    props : {
        projeto : {
            type : Object,
            required : true
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    data : () => ({
        dados : [],
        form : {},
        tituloModal : "",
    }),
    methods : {
        montar : function(){
            this.buscar();
            this.inicializarForm();
        },
        salvar : function(){
            
            this.confirmar('Aviso',
                this.projetoIniciado ?
                'Deseja criar um cronograma não previsto?' :
                'Deseja criar o cronograma de etapa?'
            ).then((result) =>{
                if (result) {

                    if(this.$refs.form.validateState() == false) return;

                    this.$store.dispatch(START_LOADING);

                    let form = cloneDeep(this.form);
                    form.projetoGestaoId = this.projeto.id;
                    form.detalhamentoProjeto = form.detalhamento;

                    if(!this.projetoIniciado){
                        form.etapa.mesInicial = form.etapa.mesInicialRealizado;
                        form.etapa.mesFinal = form.etapa.mesFinalRealizado;

                        form.etapa.mesInicialRealizado = 0;
                        form.etapa.mesFinalRealizado = 0;

                        form.subetapas = form.subetapas.map(el => {
                            el.mesFinal = el.mesFinalRealizado;
                            el.mesInicial = el.mesInicialRealizado;

                            el.mesFinalRealizado = 0;
                            el.mesInicialRealizado = 0;

                            return el;
                        })
                    }


                    ProjetoGestaoService.salvarCronograma(form).then(() => {

                        this.alertaSucesso('Cronograma salvo com sucesso!').then(() => {
                            this.inicializarForm();
                            this.buscar();
                            this.$refs.modal.closeModal();
                        });
                        
                    }).catch(err => {
                        if(err.response.status == 400){
                            this.alertaErro(`${err.response.data.errors}`)
                        }else{
                            this.alertaErro('Ocorreu um erro ao salvar o cronograma!')
                        }
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });

                } 
            });
        },


        editar : function(row){
            this.form = cloneDeep(row.form);
            this.tituloModal = row.form.etapa.tituloDaEtapa;

            if(!this.projetoIniciado){
                this.form.etapa.mesInicialRealizado = this.form.etapa.mesInicial;
                this.form.etapa.mesFinalRealizado = this.form.etapa.mesFinal;

                this.form.etapa.mesInicial = 0;
                this.form.etapa.mesFinal = 0;

                this.form.subetapas = this.form.subetapas.map(el => {
                    el.mesFinalRealizado = el.mesFinal;
                    el.mesInicialRealizado = el.mesInicial;

                    el.mesFinal = 0;
                    el.mesInicial = 0;

                    return el;
                })
            }

            this.$refs.modal.openModal();
        },
        remover : function(){
            let id = this.form.id;
            this.confirmar('Aviso','Deseja excluir o cronograma?').then((result) =>{
                if (result) {
                    this.$store.dispatch(START_LOADING);
                    ProjetoGestaoService.excluirCronograma(id).then(() => {

                        this.alertaSucesso('Cronograma excluído com sucesso!').then(() => {
                            this.inicializarForm();
                            this.buscar();
                            this.$refs.modal.closeModal();
                        });
                        
                    }).catch(err => {
                        if(err.response.status == 400){
                            this.alertaErro(`${err.response.data.errors}`)
                        }else{
                            this.alertaErro('Ocorreu um erro ao excluir o cronograma!')
                        }
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                }
            });            
        },

        inicializarForm : function(){
            this.tituloModal = "CRONOGRAMA DE ETAPAS";
            this.form = {
                etapa: {
                    numero: null,
                    tituloDaEtapa: null,
                    mesInicial: 0,
                    mesFinal: 0,
                    mesInicialRealizado: 0,
                    mesFinalRealizado: 0,
                    prevista: !this.projetoIniciado
                },
                subetapas: [],
                detalhamento: null,
                detalhamentoRealizado: null,
                previsto: !this.projetoIniciado
            }
        },

        buscar : function(){
            this.$store.dispatch(START_LOADING);
            ProjetoGestaoService.listarCronograma(this.ehTelaCooperada ? this.projeto.id : this.projeto.projetoGestaoId).then(response => {
                
                this.dados = response.data.data.sort((a,b) => a.etapa.numero - b.etapa.numero);
            }).catch(() => {
                this.alertaErro("Erro ao buscar");
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        }
    },
    mounted : function(){
        
    },
    computed: {
        projetoIniciado : function(){
            return this.projeto.faseRealizacao;
        },
        cols : function(){
            let columns = [];
            let ano = this.projeto.anoInicio;
            let mes = 4
            let dia = '01';
            if(this.projetoIniciado){
                ano = helpers.formatarData(this.projeto.dataInicio, 'YYYY');
                mes = helpers.formatarData(this.projeto.dataInicio, 'MM');
                dia = helpers.formatarData(this.projeto.dataInicio, 'DD');
            }
            let totalMeses = this.projetoIniciado ? this.duracao + 1 : this.duracao;
            for (let index = 0; index < totalMeses; index++) {
                columns.push({
                    key: index+1,
                    title: this.projetoIniciado ? `${dia}/${helpers.retornarNomeMes(mes)}/${ano}` : `Mês ${index + 1}`,
                });
                
                mes++;
                if(mes > 12){
                    mes = 1;
                    ano++;
                }
            }


            return columns;
        },
        rows: function(){
            let rows = [];

            if(this.dados)

            rows = this.dados.map(el => {
                
                let elemento = [];

                elemento.push(
                    {
                        key: `${el.id}-1`,
                        width: el.etapa.prevista ? el.etapa.mesFinal - (el.etapa.mesInicial - 1) : el.etapa.mesFinalRealizado - (el.etapa.mesInicialRealizado - 1),
                        left: el.etapa.prevista ? el.etapa.mesInicial - 1 : el.etapa.mesInicialRealizado - 1,
                        title: el.etapa.tituloDaEtapa,
                        form: el,
                        number : el.etapa.numero,
                        variant: el.etapa.prevista ? 'info' : 'primary',
                        buttonAdd : this.controlesLiberados && (this.projetoIniciado && (el.etapa.mesInicialRealizado == 0 || el.etapa.mesFinalRealizado == 0)),
                        desabilitarClick : this.projetoIniciado && el.etapa.prevista,
                    }
                );

                if(el.etapa.prevista && this.projetoIniciado){
                    elemento.push(
                        {
                            key: `${el.id}-2`,
                            width: el.etapa.mesFinalRealizado - (el.etapa.mesInicialRealizado - 1),
                            left: el.etapa.mesInicialRealizado - 1,
                            title: el.etapa.tituloDaEtapa,
                            form: el,
                            number : el.etapa.numero,
                            variant: el.etapa.mesFinalRealizado <= el.etapa.mesFinal ? 
                                        el.etapa.mesFinalRealizado < el.etapa.mesFinal ? 
                                       'danger' : 'success' 
                                    : 'warning',
                            buttonAdd : false
                        },
                    );
                }

                return elemento;
            })

            return rows;
        },
        controlesLiberados :function(){
            return this.$route.name == 'projeto-gestao-proponente-detalhamento' && this.projetoEditavel
        },
        ehTelaCooperada :function(){
            return this.$route.name == 'projeto-gestao-proponente-detalhamento'
        },
        duracao : function(){
            if(!this.ehTelaCooperada)
                return this.projeto.projetoGestao.duracao;
            return this.projeto.duracao;
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosGestaoCronogramaEtapa');
        },
    }

    
}
</script>
<style>
    .round {
        width: 20px;
        height: 20px;
        border-radius: 10px;
    }
</style>